import { useVerifyEmail } from '@hooks/useVerifyEmail';
import { Form, Input, Button } from 'antd';
import { ClockCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { motion } from 'framer-motion';
import Link from '@components/ui/Link';
import { LoginRoot, LoginWelcome, LoginSubtitle, LoginFormWrapper } from '../style';
import styled from 'styled-components';

const StyledSubmitButton = styled(Button)`
    width: 100%;
    height: 48px;
    font-size: 1rem;
    font-weight: 600;
    color: #fff !important;
    background: #8b5cf6 !important;
    border: none !important;
    border-radius: 10px;
    margin-top: 8px;
    &:hover:not(:disabled) {
        background: #7c3aed !important;
    }
`;

const ResendBtn = styled(Button)`
    width: 100%;
    height: 44px;
    margin-top: 12px;
    border-radius: 10px;
`;

const MotionRoot = motion.create(LoginRoot);

const VerifyEmail = () => {
    const { form, loading, countdown, resendLoading, email, onFinish, handleResend, formatTime } = useVerifyEmail();

    return (
        <MotionRoot
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, ease: [0.25, 0.46, 0.45, 0.94] }}
        >
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }}>
                <LoginWelcome>Verify your email</LoginWelcome>
                <LoginSubtitle>
                    We sent a 6-digit code to <strong>{email || 'your email'}</strong>. Enter it below.
                </LoginSubtitle>
            </motion.div>

            <LoginFormWrapper>
                <Form form={form} onFinish={onFinish} layout="vertical" requiredMark={false}>
                    <Form.Item name="otp" rules={[{ required: true, message: 'Please enter the 6-digit code' }]}>
                        <Input.OTP
                            length={6}
                            size="large"
                            separator={<span style={{ color: 'rgba(0,0,0,0.45)' }}>-</span>}
                            onChange={(value) => {
                                if (value.length === 6 && !loading) {
                                    form.submit();
                                }
                            }}
                            style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'space-between',
                                gap: '6px',
                            }}
                        />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <StyledSubmitButton type="primary" htmlType="submit" block loading={loading} size="large">
                            Verify & continue
                        </StyledSubmitButton>
                    </Form.Item>
                    <ResendBtn
                        size="large"
                        type={countdown > 0 ? 'default' : 'default'}
                        onClick={handleResend}
                        disabled={countdown > 0}
                        loading={resendLoading}
                        icon={countdown > 0 ? <ClockCircleOutlined /> : <ReloadOutlined />}
                        block
                    >
                        {countdown > 0 ? `Resend code in ${formatTime(countdown)}` : 'Resend code'}
                    </ResendBtn>
                </Form>
            </LoginFormWrapper>

            <Link to="/sign-in" block>
                Back to sign in
            </Link>
        </MotionRoot>
    );
};

export default VerifyEmail;
